import { apiSlice, asyncToastDisplay, i18n } from "./apiSlice";

export const audienceApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAudiences: builder.query({
      query: () => `/audiences/`,
      providesTags: (result, error, arg) => [{ type: 'Audience', id: 'LIST' }],
    }),
    getAudience: builder.query({
      query: (audienceKey) => `/audiences/${audienceKey}`,
      providesTags: (result, error, arg) => [{ type: 'Audience', id: arg }],
    }),
    createAudience: builder.mutation({
      query: (audience) => ({
        url: `/audiences/`,
        method: 'POST',
        body: audience
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.created")}),
      invalidatesTags: (result, error, arg) => [{ type: 'Audience', id: 'LIST' }],
    }),
    updateAudience: builder.mutation({
      query: (audience) => ({
        url: `/audiences/${audience.key}`,
        method: 'PUT',
        body: audience,
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, arg) => [
        { type: 'Audience', id: arg.key }, { type: 'Audience', id: 'LIST' }
      ]
    }),
    runAudience: builder.mutation({
      query: (audienceKey) => ({
        url: `/audiences/${audienceKey}/run`,
        method: 'POST'
      })
    }),
    deleteAudience: builder.mutation({
      query: (audienceKey) => ({
        url: `/audiences/${audienceKey}`,
        method: 'DELETE'
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.deleted")}),
      invalidatesTags: (result, error, arg) => [
        { type: 'Audience', id: arg.audienceId },
        { type: 'Audience', id: 'LIST' }
      ]
    }),
    getAudienceAggregationOptions: builder.query({
      query: () => ({
        url: `/audiences/aggregation_options`
      }),
      providesTags: [{ type: 'AggregationOptions' }],

    })
  }),
  overrideExisting: false
})

export const {
  useGetAudiencesQuery,
  useGetAudienceQuery,
  useGetAudienceAggregationOptionsQuery,
  useCreateAudienceMutation,
  useUpdateAudienceMutation,
  useDeleteAudienceMutation,
  useRunAudienceMutation
} = audienceApiSlice
